export default __webpack_public_path__ + "static/intelligent-automation-2-75f1b7dc8831148c432cdfbaecd797ff.png";